import { DirectionProvider } from '@radix-ui/react-direction';
import { useSyncExternalStore, type ReactNode } from 'react';
import i18n, { activeDirection } from '@/i18n';

// Radix does not read `<html dir>`. Every primitive that takes a direction
// (Tabs, DropdownMenu, …) asks this context and falls back to 'ltr' — and then
// WRITES `dir="ltr"` onto its own root element. Without the provider, Arabic
// and Hebrew got a mirrored page with an LTR island inside every tab strip,
// tab panel and menu: the attribute on the Tabs root overrode the one
// on <html> for everything rendered below it.
//
// One provider at the root rather than a `dir` prop per instance: a primitive
// added later is covered without anyone having to remember.

function subscribe(onChange: () => void): () => void {
  i18n.on('languageChanged', onChange);
  return () => i18n.off('languageChanged', onChange);
}

export function LocaleDirectionProvider({ children }: { children: ReactNode }) {
  const dir = useSyncExternalStore(subscribe, activeDirection);
  return <DirectionProvider dir={dir}>{children}</DirectionProvider>;
}
